import React, { useMemo } from 'react'
import { Route } from 'react-router-dom'
import Wind2PowerData from './Wind2PowerData'
import Wind2Plant from './admin/Wind2Plant'
import Wind2Subgroup from './admin/Wind2Subgroup'
import Wind2ContributeCondition from './admin/Wind2ContributeCondition'
import Wind2ScadaeManf from './admin/Wind2ScadaManf'
import Wind2TurbineManf from './admin/Wind2TurbineManf'
import Wind2TurbineType from './admin/Wind2TurbineType'
import Wind2InvStroageManf from './admin/Wind2InvManf'
import Wind2StroageManf from './admin/Wind2StorageManf'
import Wind2SubgroupFormation from './admin/Wind2SubgroupFormation'
import Wind2NercRegion from './admin/Wind2NercRegion'
import Wind2Level2Validation from './Wind2Level2Validation'
import Wind2Causecode from './admin/Wind2Causecode'
import Wind2TurbinePowerData from './Wind2TurbinePowerData'
import Wind2StorageGroup from './admin/Wind2StorageGroup'

import { hasAccesPermits } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
import Wind2Entity from './admin/Wind2Entity'
import Wind2Errors from './admin/Wind2Errors'
import Wind2Lockcheck from './admin/Wind2Lockcheck'
import WindUserPlant from './admin/WindUserPlant'

// import Wind2ImportFile from './Wind2ImportFile'
import Wind2ImportFileOnly from './Wind2ImportFileOnly'
import Wind2Report from './Wind2Report'
import Wind2FileCreation from './windfilecreation/Wind2FileCreation'
import Wind2FileImport from './windfilecreation/Wind2FileImport'
import Wind2PiDataImport from './Wind2PiDataImport'
import Wind2PIMissingData from './Wind2PIMissingData'
import Wind2PiRow10MinData from '../pirowdata/wind2/Wind2PiRow10MinData'
import Wind2PiRowHourlyData from '../pirowdata/wind2/Wind2PiRowHourlyData'
import Wind2PiRowDailyData from '../pirowdata/wind2/Wind2PiRowDailyData'
export default Wind2PowerData

const Wind2Container = ({ actionPermits, envConfig }) => {
  const windAdminScreenAccess = useMemo(
    _ =>
      hasAccesPermits({
        authGodMode: envConfig.authGodMode,
        actionPermits,
        eventActions: [ScreenPermissions.WIND_ADMIN_SCRREEN_PERMISSIONS_20],
        matchAny: true,
      }),
    [actionPermits, envConfig.authGodMode]
  )
  const hasWindPowerData20 = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.WIND_POWER_DATA_20,
          ScreenPermissions.WIND_ADMIN_POWER_DATA_20,
        ],
        matchAny: true,
      }),
    [actionPermits]
  )

  const windImportCsv = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND_IMPORT_CSV_20],
        matchAny: true,
      }),
    [actionPermits]
  )

  const windReport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND_REPORT_20],
        matchAny: true,
      }),
    [actionPermits]
  )
  const wind2FileCreation = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_CREATION],
        matchAny: true,
      }),
    [actionPermits]
  )

  const wind2FileImport = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_FILE_IMPORT],
        matchAny: true,
      }),
    [actionPermits]
  )

  const windPiImportIntervals = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_IMPORT_INTERVALS],
        matchAny: true,
      }),
    [actionPermits]
  )

  const windPiImportMissing = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_MISSING_DATA],
        matchAny: true,
      }),
    [actionPermits]
  )

  const hasWind2PiRawData = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [ScreenPermissions.WIND2_PI_ROW_DATA_READ],
        matchAny: true,
      }),
    [actionPermits]
  )

  return (
    <React.Fragment>
      {windReport && (
        <Route exact path="/wind2/wind-report-20" component={Wind2Report} />
      )}

      {hasWindPowerData20 && (
        <React.Fragment>
          <Route
            exact
            path="/wind2/wind-power-data-20"
            component={Wind2PowerData}
          />
          <Route
            exact
            path="/wind2/wind2-level2-validation"
            component={Wind2Level2Validation}
          />
          <Route
            exact
            path="/wind2/wind-turbine-power-data-20"
            component={Wind2TurbinePowerData}
          />
          {windImportCsv && (
            <Route
              exact
              path="/wind2/wind-import-20"
              component={Wind2ImportFileOnly}
            />
          )}
          {windPiImportIntervals && (
            <Route
              exact
              path="/wind2/wind2-pi-import-intervals"
              component={Wind2PiDataImport}
              key="wind2-pi-import-intervals"
            />
          )}
          {windPiImportMissing && (
            <Route
              exact
              path="/wind2/wind2-pi-missing-data"
              component={Wind2PIMissingData}
              key="wind2-pi-missing-data"
            />
          )}
        </React.Fragment>
      )}
      {windAdminScreenAccess && (
        <React.Fragment>
          <Route
            exact
            path="/wind2/subgroup-formation"
            component={Wind2SubgroupFormation}
          />
          <Route exact path="/wind2/plants" component={Wind2Plant} />
          <Route exact path="/wind2/subgroup" component={Wind2Subgroup} />
          <Route
            exact
            path="/wind2/storage-group"
            component={Wind2StorageGroup}
          />
          <Route exact path="/wind2/scada" component={Wind2ScadaeManf} />
          <Route exact path="/wind2/turb-manf" component={Wind2TurbineManf} />
          <Route exact path="/wind2/turb-type" component={Wind2TurbineType} />
          <Route exact path="/wind2/entity" component={Wind2Entity} />
          <Route exact path="/wind2/region" component={Wind2NercRegion} />
          <Route
            exact
            path="/wind2/storage-manf"
            component={Wind2StroageManf}
          />
          <Route
            exact
            path="/wind2/storage-inv-manf"
            component={Wind2InvStroageManf}
          />
          <Route
            exact
            path="/wind2/contribcond"
            component={Wind2ContributeCondition}
          />
          <Route exact path="/wind2/causecode" component={Wind2Causecode} />
          <Route exact path="/wind2/errors" component={Wind2Errors} />
          <Route exact path="/wind2/lockcheck" component={Wind2Lockcheck} />

          <Route
            exact
            path="/wind2/user-access-right"
            component={WindUserPlant}
          />
        </React.Fragment>
      )}
      {wind2FileCreation && (
        <Route
          exact
          path="/wind2/wind2-file-creation"
          component={Wind2FileCreation}
          // key={2}
        />
      )}
      {wind2FileImport && (
        <Route
          exact
          path="/wind2/wind2-file-import"
          component={Wind2FileImport}
        />
      )}
      {hasWind2PiRawData && (
        <React.Fragment>
          <Route
            exact
            path="/wind2/pi-row-10min-data"
            component={Wind2PiRow10MinData}
            key="wind2/pi-row-10min-data"
          />

          <Route
            exact
            path="/wind2/pi-row-hourly-data"
            component={Wind2PiRowHourlyData}
            key="wind2/pi-row-hourly-data"
          />

          <Route
            exact
            path="/wind2/pi-row-daily-data"
            component={Wind2PiRowDailyData}
            key="wind2/pi-row-daily-data"
          />
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export { Wind2Container }
